import { render, staticRenderFns } from "./WineryTable.vue?vue&type=template&id=11d9ce1a&scoped=true&"
import script from "./WineryTable.vue?vue&type=script&lang=ts&"
export * from "./WineryTable.vue?vue&type=script&lang=ts&"
import style0 from "./WineryTable.vue?vue&type=style&index=0&id=11d9ce1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d9ce1a",
  null
  
)

export default component.exports